"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _xApiStatementFactory = _interopRequireDefault(require("../xApi/xApiStatementFactory"));

var _configOptions = require("../constants/config-options");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Format event value names to kebab case for use in IRI's.
 *
 * @param {String} name
 * @return {String} The formatted name.
 */
function formatName(name) {
  if (!name) return '';
  return name.replace(/\s+/g, '-').toLowerCase();
}

var EventService =
/*#__PURE__*/
function () {
  /**
   * Initialize the service by setting up an event factory with configuration.
   *
   * @param {Object} config
   */
  function EventService(config) {
    _classCallCheck(this, EventService);

    this.eventFactory = new _xApiStatementFactory["default"](config, config[_configOptions.CONFIG_OPTIONS.ENVIRONMENT]);
    this.stashedEventsKey = "stashedEvents-".concat(formatName(config[_configOptions.CONFIG_OPTIONS.APP_NAME]), "-") + "".concat(config[_configOptions.CONFIG_OPTIONS.USER_ID]);
    this.config = config;

    if (config[_configOptions.CONFIG_OPTIONS.APP_NAME] && config[_configOptions.CONFIG_OPTIONS.USER_ID]) {
      // Send any stashed events.
      this.sendStashedEvents();
    }
  }
  /**
   * Create a new xAPI event and add basic actor data.
   *
   * @return {Object} The event.
   */


  _createClass(EventService, [{
    key: "createEvent",
    value: function createEvent() {
      return this.eventFactory.create().addActorAccount('name', this.config[_configOptions.CONFIG_OPTIONS.USER_ID]);
    }
    /**
     * Add verb data to an event, representing the action being done. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {String} name The verb name.
     */

  }, {
    key: "addVerb",
    value: function addVerb(event, name) {
      event.addVerbId(name).addVerb('display', _defineProperty({}, this.config[_configOptions.CONFIG_OPTIONS.LANGUAGE], name));
    }
    /**
     * Add object data to an event, representing the page element being acted upon. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {String} elementName The name of the element being acted on.
     * @param {String} elementType The type of element being acted on.
     */

  }, {
    key: "addObject",
    value: function addObject(event, elementName, elementType) {
      event.addObjectId('page-element', formatName(elementName), window.location.href).addObject('objectType', 'Activity').addObjectDefinition('name', elementName).addObjectExtension('page-element-type', elementType);
    }
    /**
     * Add context extension data to an event when there is useful additional context to log. Transforms the passed
     * in event.
     *
     * @param {Object} event
     * @param {Object} extensions
     */

  }, {
    key: "addContext",
    value: function addContext(event, extensions) {
      Object.keys(extensions).forEach(function (key) {
        event.addContextExtension(key, extensions[key]);
      });
    }
    /**
     * Stash event in localStorage, to be sent when app is next loaded. Used for events captured on leaving the app.
     *
     * @param {Object} event
     */

  }, {
    key: "stashEvent",
    value: function stashEvent(event) {
      event.setTimestamp(new Date().toISOString());
      var stashedEvents = localStorage.getItem(this.stashedEventsKey);

      try {
        stashedEvents = stashedEvents ? JSON.parse(stashedEvents) : [];
        localStorage.setItem(this.stashedEventsKey, JSON.stringify(stashedEvents.concat([event])));
      } catch (error) {
        console.error(error);
      }
    }
    /**
     * Send any events that have been stashed in localStorage.
     *
     * @return {Promise}
     */

  }, {
    key: "sendStashedEvents",
    value: function sendStashedEvents() {
      var _this = this;

      var stashedEvents = localStorage.getItem(this.stashedEventsKey);
      var promises = [];

      if (stashedEvents) {
        try {
          JSON.parse(stashedEvents).forEach(function (stashedEvent) {
            var event = _this.createEvent();

            event.statement = Object.assign(event.statement, stashedEvent.statement);
            promises.push(event.emit());
          });
        } catch (error) {
          console.error(error);
        }

        localStorage.removeItem(this.stashedEventsKey);
      }

      return Promise.all(promises);
    }
    /**
     * Send an xAPI event when an app is loaded.
     *
     * @return {Promise}
     */

  }, {
    key: "sendAppLoadedEvent",
    value: function sendAppLoadedEvent() {
      var event = this.createEvent();
      this.addVerb(event, 'loaded');
      this.addObject(event, this.config[_configOptions.CONFIG_OPTIONS.APP_NAME], 'app');
      return event.emit();
    }
    /**
     * Send an xAPI event when the app is unloaded.
     *
     * @return {Promise}
     */

  }, {
    key: "sendAppUnloadedEvent",
    value: function sendAppUnloadedEvent() {
      var event = this.createEvent();
      this.addVerb(event, 'unloaded');
      this.addObject(event, this.config[_configOptions.CONFIG_OPTIONS.APP_NAME], 'app');
      return event.emit();
    }
    /**
     * Stash an xAPI event when the app is unloaded.
     */

  }, {
    key: "stashAppUnloadedEvent",
    value: function stashAppUnloadedEvent() {
      var event = this.createEvent();
      this.addVerb(event, 'unloaded');
      this.addObject(event, this.config[_configOptions.CONFIG_OPTIONS.APP_NAME], 'app');
      this.stashEvent(event);
    }
    /**
     * Send an xAPI event when a page is opened.
     *
     * @param {String} page The page name or path.
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @return {Promise}
     */

  }, {
    key: "sendPageOpenedEvent",
    value: function sendPageOpenedEvent(page, contextExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'opened');
      this.addObject(event, page, 'page');

      if (contextExtensions) {
        this.addContext(event, contextExtensions);
      }

      return event.emit();
    }
    /**
     * Send an xAPI event when a page is closed.
     *
     * @param {String} page The page name or path.
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @return {Promise}
     */

  }, {
    key: "sendPageClosedEvent",
    value: function sendPageClosedEvent(page, contextExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'closed');
      this.addObject(event, page, 'page');

      if (contextExtensions) {
        this.addContext(event, contextExtensions);
      }

      return event.emit();
    }
    /**
     * Stash an xAPI event when a page is closed.
     *
     * @param {String} page The page name or path.
     * @param {Object?} contextExtensions Optiional data representing the context for the event.
     */

  }, {
    key: "stashPageClosedEvent",
    value: function stashPageClosedEvent(page, contextExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'closed');
      this.addObject(event, page, 'page');

      if (contextExtensions) {
        this.addContext(event, contextExtensions);
      }

      this.stashEvent(event);
    }
  }]);

  return EventService;
}();

var _default = EventService;
exports["default"] = _default;
module.exports = exports.default;